import { type FC, PropsWithChildren } from 'react'
import Button from '../Button'
import { icons } from '../../../icons/IconSet'

const TrackingButton: FC<PropsWithChildren<{ onClick?: () => void }>> = ({ children, onClick }) => (
  <Button
    className='flex items-center gap-2'
    isNotFullWidth
    type='inline'
    size='small'
    variant='outline'
    onClick={() => onClick?.()}
  >
    {icons('truck', { width: '1.3em' })} {children}
  </Button>
)

export default TrackingButton
